import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A high precision floating point value represented as a string */
  BigFloat: { input: any; output: any; }
  /** An arbitrary size integer represented as a string */
  BigInt: { input: any; output: any; }
  /** An opaque string using for tracking a position in results during pagination */
  Cursor: { input: any; output: any; }
  /** A date without time information */
  Date: { input: string; output: string; }
  /** A date and time */
  Datetime: { input: any; output: any; }
  /** A Javascript Object Notation value serialized as a string */
  JSON: { input: any; output: any; }
  /** Any type not handled by the type system */
  Opaque: { input: any; output: any; }
  /** A time without date information */
  Time: { input: string; output: string; }
  /** A universally unique identifier */
  UUID: { input: string; output: string; }
};

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
  eq?: InputMaybe<Scalars['BigFloat']['input']>;
  gt?: InputMaybe<Scalars['BigFloat']['input']>;
  gte?: InputMaybe<Scalars['BigFloat']['input']>;
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigFloat']['input']>;
  lte?: InputMaybe<Scalars['BigFloat']['input']>;
  neq?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
  eq?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  neq?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  contains?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  eq?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
};

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Date']['input']>>;
  contains?: InputMaybe<Array<Scalars['Date']['input']>>;
  eq?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
  eq?: InputMaybe<Scalars['Datetime']['input']>;
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
  neq?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  contains?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  eq?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export enum FilterIs {
  NotNull = 'NOT_NULL',
  Null = 'NULL'
}

/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Float']['input']>>;
  contains?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Int']['input']>>;
  contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The root type for creating and mutating data */
export type Mutation = {
  __typename?: 'Mutation';
  advance_community_notice_read_watermark?: Maybe<Scalars['Opaque']['output']>;
  apply_notice_publish_with_events?: Maybe<Scalars['Opaque']['output']>;
  archive_community?: Maybe<Scalars['Opaque']['output']>;
  claim_notice_push_send?: Maybe<Scalars['Boolean']['output']>;
  complete_notice_push_send?: Maybe<Scalars['Boolean']['output']>;
  create_community?: Maybe<Scalars['UUID']['output']>;
  create_notice?: Maybe<Scalars['UUID']['output']>;
  delete_community_event?: Maybe<Scalars['Opaque']['output']>;
  delete_notice?: Maybe<Scalars['Opaque']['output']>;
  delete_notice_image?: Maybe<Scalars['String']['output']>;
  delete_push_subscription?: Maybe<Scalars['Opaque']['output']>;
  ensure_member_by_invite_code?: Maybe<Scalars['UUID']['output']>;
  invoke_notify_due_notices?: Maybe<Scalars['Opaque']['output']>;
  leave_community?: Maybe<Scalars['Opaque']['output']>;
  release_notice_push_send?: Maybe<Scalars['Opaque']['output']>;
  rotate_community_invite_code?: Maybe<Scalars['String']['output']>;
  set_community_icon?: Maybe<Scalars['Opaque']['output']>;
  set_profile_avatar?: Maybe<Scalars['Opaque']['output']>;
  sync_profile_from_auth?: Maybe<Scalars['Opaque']['output']>;
  update_community_calendar_enabled?: Maybe<Scalars['Opaque']['output']>;
  update_community_guest_joins?: Maybe<Scalars['Opaque']['output']>;
  update_community_member_role?: Maybe<Scalars['Opaque']['output']>;
  update_community_name?: Maybe<Scalars['Opaque']['output']>;
  update_notice?: Maybe<Scalars['Opaque']['output']>;
  update_profile_display_name?: Maybe<Scalars['Opaque']['output']>;
  update_profile_preferred_language?: Maybe<Scalars['Opaque']['output']>;
  upsert_community_event?: Maybe<Scalars['UUID']['output']>;
  upsert_push_subscription?: Maybe<Scalars['Opaque']['output']>;
};


/** The root type for creating and mutating data */
export type MutationAdvance_Community_Notice_Read_WatermarkArgs = {
  p_community_id: Scalars['UUID']['input'];
  p_publish_at: Scalars['Datetime']['input'];
};


/** The root type for creating and mutating data */
export type MutationApply_Notice_Publish_With_EventsArgs = {
  p_clear_publish_at?: InputMaybe<Scalars['Boolean']['input']>;
  p_delete_event_ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  p_events?: InputMaybe<Scalars['JSON']['input']>;
  p_notice_id: Scalars['UUID']['input'];
  p_publish_at?: InputMaybe<Scalars['Datetime']['input']>;
  p_update_publish?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root type for creating and mutating data */
export type MutationArchive_CommunityArgs = {
  p_community_id: Scalars['UUID']['input'];
  p_confirmation_name: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationClaim_Notice_Push_SendArgs = {
  p_notice_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationComplete_Notice_Push_SendArgs = {
  p_notice_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationCreate_CommunityArgs = {
  p_allow_guest_joins?: InputMaybe<Scalars['Boolean']['input']>;
  p_calendar_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  p_name: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationCreate_NoticeArgs = {
  p_community_id: Scalars['UUID']['input'];
  p_title: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationDelete_Community_EventArgs = {
  p_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationDelete_NoticeArgs = {
  p_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationDelete_Notice_ImageArgs = {
  p_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationDelete_Push_SubscriptionArgs = {
  p_endpoint: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationEnsure_Member_By_Invite_CodeArgs = {
  p_code: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationLeave_CommunityArgs = {
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationRelease_Notice_Push_SendArgs = {
  p_notice_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationRotate_Community_Invite_CodeArgs = {
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationSet_Community_IconArgs = {
  p_clear?: InputMaybe<Scalars['Boolean']['input']>;
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationSet_Profile_AvatarArgs = {
  p_clear?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root type for creating and mutating data */
export type MutationSync_Profile_From_AuthArgs = {
  p_email: Scalars['String']['input'];
  p_full_name?: InputMaybe<Scalars['String']['input']>;
};


/** The root type for creating and mutating data */
export type MutationUpdate_Community_Calendar_EnabledArgs = {
  p_calendar_enabled: Scalars['Boolean']['input'];
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdate_Community_Guest_JoinsArgs = {
  p_allow_guest_joins: Scalars['Boolean']['input'];
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdate_Community_Member_RoleArgs = {
  p_community_id: Scalars['UUID']['input'];
  p_role: Scalars['String']['input'];
  p_user_id: Scalars['UUID']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdate_Community_NameArgs = {
  p_community_id: Scalars['UUID']['input'];
  p_name: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdate_NoticeArgs = {
  p_clear_publish_at?: InputMaybe<Scalars['Boolean']['input']>;
  p_id: Scalars['UUID']['input'];
  p_parts?: InputMaybe<Scalars['JSON']['input']>;
  p_publish_at?: InputMaybe<Scalars['Datetime']['input']>;
  p_title?: InputMaybe<Scalars['String']['input']>;
};


/** The root type for creating and mutating data */
export type MutationUpdate_Profile_Display_NameArgs = {
  p_display_name: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdate_Profile_Preferred_LanguageArgs = {
  p_preferred_language: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpsert_Community_EventArgs = {
  p_community_id: Scalars['UUID']['input'];
  p_end_date?: InputMaybe<Scalars['Date']['input']>;
  p_end_time?: InputMaybe<Scalars['Time']['input']>;
  p_id?: InputMaybe<Scalars['UUID']['input']>;
  p_notice_id: Scalars['UUID']['input'];
  p_start_date: Scalars['Date']['input'];
  p_start_time?: InputMaybe<Scalars['Time']['input']>;
  p_title: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpsert_Push_SubscriptionArgs = {
  p_auth: Scalars['String']['input'];
  p_endpoint: Scalars['String']['input'];
  p_p256dh: Scalars['String']['input'];
};

export type Node = {
  /** Retrieves a record by `ID` */
  nodeId: Scalars['ID']['output'];
};

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
  eq?: InputMaybe<Scalars['Opaque']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Defines a per-field sorting order */
export enum OrderByDirection {
  /** Ascending order, nulls first */
  AscNullsFirst = 'AscNullsFirst',
  /** Ascending order, nulls last */
  AscNullsLast = 'AscNullsLast',
  /** Descending order, nulls first */
  DescNullsFirst = 'DescNullsFirst',
  /** Descending order, nulls last */
  DescNullsLast = 'DescNullsLast'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The root type for querying data */
export type Query = {
  __typename?: 'Query';
  can_select_notice?: Maybe<Scalars['Boolean']['output']>;
  can_select_notice_image_object?: Maybe<Scalars['Boolean']['output']>;
  can_select_notice_row?: Maybe<Scalars['Boolean']['output']>;
  /** A pagable collection of type `communities` */
  communitiesCollection?: Maybe<CommunitiesConnection>;
  /** A pagable collection of type `community_events` */
  community_eventsCollection?: Maybe<Community_EventsConnection>;
  /** A pagable collection of type `community_members` */
  community_membersCollection?: Maybe<Community_MembersConnection>;
  /** A pagable collection of type `community_members_with_profile` */
  community_members_with_profileCollection?: Maybe<Community_Members_With_ProfileConnection>;
  get_community_first_unread_notice_id?: Maybe<Scalars['UUID']['output']>;
  get_community_invite_code?: Maybe<Scalars['String']['output']>;
  is_community_admin?: Maybe<Scalars['Boolean']['output']>;
  is_member_by_invite_code?: Maybe<Scalars['Boolean']['output']>;
  is_member_of_community?: Maybe<Scalars['Boolean']['output']>;
  is_member_of_notice_community?: Maybe<Scalars['Boolean']['output']>;
  is_sole_community_admin?: Maybe<Scalars['Boolean']['output']>;
  my_active_admin_community_ids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  my_active_member_community_ids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  my_admin_community_ids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /** A pagable collection of type `my_communities_feed` */
  my_communities_feedCollection?: Maybe<My_Communities_FeedConnection>;
  my_community_ids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /** Retrieve a record by its `ID` */
  node?: Maybe<Node>;
  /** A pagable collection of type `notice_images` */
  notice_imagesCollection?: Maybe<Notice_ImagesConnection>;
  notice_is_live?: Maybe<Scalars['Boolean']['output']>;
  notice_parts_images_belong_to_notice?: Maybe<Scalars['Boolean']['output']>;
  notice_parts_visible_count?: Maybe<Scalars['Int']['output']>;
  /** A pagable collection of type `notices` */
  noticesCollection?: Maybe<NoticesConnection>;
  /** A pagable collection of type `profiles` */
  profilesCollection?: Maybe<ProfilesConnection>;
  /** A pagable collection of type `push_subscriptions` */
  push_subscriptionsCollection?: Maybe<Push_SubscriptionsConnection>;
  was_member_of_archived_community?: Maybe<Scalars['Boolean']['output']>;
};


/** The root type for querying data */
export type QueryCan_Select_NoticeArgs = {
  p_notice_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryCan_Select_Notice_Image_ObjectArgs = {
  p_object_name: Scalars['String']['input'];
};


/** The root type for querying data */
export type QueryCan_Select_Notice_RowArgs = {
  p_community_id: Scalars['UUID']['input'];
  p_publish_at: Scalars['Datetime']['input'];
};


/** The root type for querying data */
export type QueryCommunitiesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<CommunitiesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommunitiesOrderBy>>;
};


/** The root type for querying data */
export type QueryCommunity_EventsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_EventsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Community_EventsOrderBy>>;
};


/** The root type for querying data */
export type QueryCommunity_MembersCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_MembersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Community_MembersOrderBy>>;
};


/** The root type for querying data */
export type QueryCommunity_Members_With_ProfileCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_Members_With_ProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Community_Members_With_ProfileOrderBy>>;
};


/** The root type for querying data */
export type QueryGet_Community_First_Unread_Notice_IdArgs = {
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryGet_Community_Invite_CodeArgs = {
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryIs_Community_AdminArgs = {
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryIs_Member_By_Invite_CodeArgs = {
  p_code: Scalars['String']['input'];
};


/** The root type for querying data */
export type QueryIs_Member_Of_CommunityArgs = {
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryIs_Member_Of_Notice_CommunityArgs = {
  p_notice_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryIs_Sole_Community_AdminArgs = {
  p_community_id: Scalars['UUID']['input'];
};


/** The root type for querying data */
export type QueryMy_Communities_FeedCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<My_Communities_FeedFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<My_Communities_FeedOrderBy>>;
};


/** The root type for querying data */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root type for querying data */
export type QueryNotice_ImagesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Notice_ImagesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Notice_ImagesOrderBy>>;
};


/** The root type for querying data */
export type QueryNotice_Is_LiveArgs = {
  p_publish_at: Scalars['Datetime']['input'];
};


/** The root type for querying data */
export type QueryNotice_Parts_Images_Belong_To_NoticeArgs = {
  p_notice_id: Scalars['UUID']['input'];
  p_parts: Scalars['JSON']['input'];
};


/** The root type for querying data */
export type QueryNotice_Parts_Visible_CountArgs = {
  p_parts: Scalars['JSON']['input'];
};


/** The root type for querying data */
export type QueryNoticesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NoticesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NoticesOrderBy>>;
};


/** The root type for querying data */
export type QueryProfilesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ProfilesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfilesOrderBy>>;
};


/** The root type for querying data */
export type QueryPush_SubscriptionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Push_SubscriptionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Push_SubscriptionsOrderBy>>;
};


/** The root type for querying data */
export type QueryWas_Member_Of_Archived_CommunityArgs = {
  p_community_id: Scalars['UUID']['input'];
};

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  iregex?: InputMaybe<Scalars['String']['input']>;
  is?: InputMaybe<FilterIs>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
  containedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
  neq?: InputMaybe<Scalars['Time']['input']>;
};

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Time']['input']>>;
  contains?: InputMaybe<Array<Scalars['Time']['input']>>;
  eq?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
  containedBy?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contains?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eq?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type Communities = Node & {
  __typename?: 'communities';
  allow_guest_joins: Scalars['Boolean']['output'];
  archived_at?: Maybe<Scalars['Datetime']['output']>;
  archived_by?: Maybe<Scalars['UUID']['output']>;
  calendar_enabled: Scalars['Boolean']['output'];
  community_eventsCollection?: Maybe<Community_EventsConnection>;
  community_membersCollection?: Maybe<Community_MembersConnection>;
  created_at: Scalars['Datetime']['output'];
  created_by: Scalars['UUID']['output'];
  icon_path?: Maybe<Scalars['String']['output']>;
  icon_updated_at?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  invite_code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  noticesCollection?: Maybe<NoticesConnection>;
};


export type CommunitiesCommunity_EventsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_EventsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Community_EventsOrderBy>>;
};


export type CommunitiesCommunity_MembersCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_MembersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Community_MembersOrderBy>>;
};


export type CommunitiesNoticesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NoticesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NoticesOrderBy>>;
};

export type CommunitiesConnection = {
  __typename?: 'communitiesConnection';
  edges: Array<CommunitiesEdge>;
  pageInfo: PageInfo;
};

export type CommunitiesEdge = {
  __typename?: 'communitiesEdge';
  cursor: Scalars['String']['output'];
  node: Communities;
};

export type CommunitiesFilter = {
  allow_guest_joins?: InputMaybe<BooleanFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<CommunitiesFilter>>;
  archived_at?: InputMaybe<DatetimeFilter>;
  archived_by?: InputMaybe<UuidFilter>;
  calendar_enabled?: InputMaybe<BooleanFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  icon_path?: InputMaybe<StringFilter>;
  icon_updated_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  invite_code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<CommunitiesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<CommunitiesFilter>>;
};

export type CommunitiesOrderBy = {
  allow_guest_joins?: InputMaybe<OrderByDirection>;
  archived_at?: InputMaybe<OrderByDirection>;
  archived_by?: InputMaybe<OrderByDirection>;
  calendar_enabled?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  icon_path?: InputMaybe<OrderByDirection>;
  icon_updated_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  invite_code?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
};

export type Community_Events = Node & {
  __typename?: 'community_events';
  communities?: Maybe<Communities>;
  community_id: Scalars['UUID']['output'];
  created_at: Scalars['Datetime']['output'];
  created_by?: Maybe<Scalars['UUID']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  end_time?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  list_key?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notice_id: Scalars['UUID']['output'];
  notices?: Maybe<Notices>;
  start_date: Scalars['Date']['output'];
  start_sort?: Maybe<Scalars['Datetime']['output']>;
  start_time?: Maybe<Scalars['Time']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['Datetime']['output'];
};

export type Community_EventsConnection = {
  __typename?: 'community_eventsConnection';
  edges: Array<Community_EventsEdge>;
  pageInfo: PageInfo;
};

export type Community_EventsEdge = {
  __typename?: 'community_eventsEdge';
  cursor: Scalars['String']['output'];
  node: Community_Events;
};

export type Community_EventsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Community_EventsFilter>>;
  community_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  end_date?: InputMaybe<DateFilter>;
  end_time?: InputMaybe<TimeFilter>;
  id?: InputMaybe<UuidFilter>;
  list_key?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Community_EventsFilter>;
  notice_id?: InputMaybe<UuidFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Community_EventsFilter>>;
  start_date?: InputMaybe<DateFilter>;
  start_sort?: InputMaybe<DatetimeFilter>;
  start_time?: InputMaybe<TimeFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Community_EventsOrderBy = {
  community_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  end_date?: InputMaybe<OrderByDirection>;
  end_time?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  list_key?: InputMaybe<OrderByDirection>;
  notice_id?: InputMaybe<OrderByDirection>;
  start_date?: InputMaybe<OrderByDirection>;
  start_sort?: InputMaybe<OrderByDirection>;
  start_time?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Community_Members = Node & {
  __typename?: 'community_members';
  communities?: Maybe<Communities>;
  community_id: Scalars['UUID']['output'];
  joined_at: Scalars['Datetime']['output'];
  last_read_publish_at?: Maybe<Scalars['Datetime']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  profiles?: Maybe<Profiles>;
  role: Scalars['String']['output'];
  user_id: Scalars['UUID']['output'];
};

export type Community_MembersConnection = {
  __typename?: 'community_membersConnection';
  edges: Array<Community_MembersEdge>;
  pageInfo: PageInfo;
};

export type Community_MembersEdge = {
  __typename?: 'community_membersEdge';
  cursor: Scalars['String']['output'];
  node: Community_Members;
};

export type Community_MembersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Community_MembersFilter>>;
  community_id?: InputMaybe<UuidFilter>;
  joined_at?: InputMaybe<DatetimeFilter>;
  last_read_publish_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Community_MembersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Community_MembersFilter>>;
  role?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Community_MembersOrderBy = {
  community_id?: InputMaybe<OrderByDirection>;
  joined_at?: InputMaybe<OrderByDirection>;
  last_read_publish_at?: InputMaybe<OrderByDirection>;
  role?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Community_Members_With_Profile = Node & {
  __typename?: 'community_members_with_profile';
  avatar_path?: Maybe<Scalars['String']['output']>;
  avatar_updated_at?: Maybe<Scalars['Datetime']['output']>;
  community_id?: Maybe<Scalars['UUID']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['UUID']['output']>;
};

export type Community_Members_With_ProfileConnection = {
  __typename?: 'community_members_with_profileConnection';
  edges: Array<Community_Members_With_ProfileEdge>;
  pageInfo: PageInfo;
};

export type Community_Members_With_ProfileEdge = {
  __typename?: 'community_members_with_profileEdge';
  cursor: Scalars['String']['output'];
  node: Community_Members_With_Profile;
};

export type Community_Members_With_ProfileFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Community_Members_With_ProfileFilter>>;
  avatar_path?: InputMaybe<StringFilter>;
  avatar_updated_at?: InputMaybe<DatetimeFilter>;
  community_id?: InputMaybe<UuidFilter>;
  display_name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Community_Members_With_ProfileFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Community_Members_With_ProfileFilter>>;
  role?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Community_Members_With_ProfileOrderBy = {
  avatar_path?: InputMaybe<OrderByDirection>;
  avatar_updated_at?: InputMaybe<OrderByDirection>;
  community_id?: InputMaybe<OrderByDirection>;
  display_name?: InputMaybe<OrderByDirection>;
  role?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type My_Communities_Feed = Node & {
  __typename?: 'my_communities_feed';
  activity_at?: Maybe<Scalars['Datetime']['output']>;
  allow_guest_joins?: Maybe<Scalars['Boolean']['output']>;
  calendar_enabled?: Maybe<Scalars['Boolean']['output']>;
  icon_path?: Maybe<Scalars['String']['output']>;
  icon_updated_at?: Maybe<Scalars['Datetime']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  last_notice_publish_at?: Maybe<Scalars['Datetime']['output']>;
  last_notice_title?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
  unread_count?: Maybe<Scalars['BigInt']['output']>;
};

export type My_Communities_FeedConnection = {
  __typename?: 'my_communities_feedConnection';
  edges: Array<My_Communities_FeedEdge>;
  pageInfo: PageInfo;
};

export type My_Communities_FeedEdge = {
  __typename?: 'my_communities_feedEdge';
  cursor: Scalars['String']['output'];
  node: My_Communities_Feed;
};

export type My_Communities_FeedFilter = {
  activity_at?: InputMaybe<DatetimeFilter>;
  allow_guest_joins?: InputMaybe<BooleanFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<My_Communities_FeedFilter>>;
  calendar_enabled?: InputMaybe<BooleanFilter>;
  icon_path?: InputMaybe<StringFilter>;
  icon_updated_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  last_notice_publish_at?: InputMaybe<DatetimeFilter>;
  last_notice_title?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<My_Communities_FeedFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<My_Communities_FeedFilter>>;
  role?: InputMaybe<StringFilter>;
  unread_count?: InputMaybe<BigIntFilter>;
};

export type My_Communities_FeedOrderBy = {
  activity_at?: InputMaybe<OrderByDirection>;
  allow_guest_joins?: InputMaybe<OrderByDirection>;
  calendar_enabled?: InputMaybe<OrderByDirection>;
  icon_path?: InputMaybe<OrderByDirection>;
  icon_updated_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_notice_publish_at?: InputMaybe<OrderByDirection>;
  last_notice_title?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  role?: InputMaybe<OrderByDirection>;
  unread_count?: InputMaybe<OrderByDirection>;
};

export type Notice_Images = Node & {
  __typename?: 'notice_images';
  created_at: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notice_id: Scalars['UUID']['output'];
  notices?: Maybe<Notices>;
  sort_order: Scalars['Int']['output'];
  storage_path: Scalars['String']['output'];
};

export type Notice_ImagesConnection = {
  __typename?: 'notice_imagesConnection';
  edges: Array<Notice_ImagesEdge>;
  pageInfo: PageInfo;
};

export type Notice_ImagesEdge = {
  __typename?: 'notice_imagesEdge';
  cursor: Scalars['String']['output'];
  node: Notice_Images;
};

export type Notice_ImagesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Notice_ImagesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Notice_ImagesFilter>;
  notice_id?: InputMaybe<UuidFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Notice_ImagesFilter>>;
  sort_order?: InputMaybe<IntFilter>;
  storage_path?: InputMaybe<StringFilter>;
};

export type Notice_ImagesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  notice_id?: InputMaybe<OrderByDirection>;
  sort_order?: InputMaybe<OrderByDirection>;
  storage_path?: InputMaybe<OrderByDirection>;
};

export type Notices = Node & {
  __typename?: 'notices';
  body_text: Scalars['String']['output'];
  communities?: Maybe<Communities>;
  community_eventsCollection?: Maybe<Community_EventsConnection>;
  community_id: Scalars['UUID']['output'];
  created_at: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notice_imagesCollection?: Maybe<Notice_ImagesConnection>;
  parts: Scalars['JSON']['output'];
  publish_at?: Maybe<Scalars['Datetime']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['Datetime']['output'];
};


export type NoticesCommunity_EventsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_EventsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Community_EventsOrderBy>>;
};


export type NoticesNotice_ImagesCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Notice_ImagesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Notice_ImagesOrderBy>>;
};

export type NoticesConnection = {
  __typename?: 'noticesConnection';
  edges: Array<NoticesEdge>;
  pageInfo: PageInfo;
};

export type NoticesEdge = {
  __typename?: 'noticesEdge';
  cursor: Scalars['String']['output'];
  node: Notices;
};

export type NoticesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NoticesFilter>>;
  body_text?: InputMaybe<StringFilter>;
  community_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NoticesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NoticesFilter>>;
  publish_at?: InputMaybe<DatetimeFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type NoticesOrderBy = {
  body_text?: InputMaybe<OrderByDirection>;
  community_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  publish_at?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Profiles = Node & {
  __typename?: 'profiles';
  avatar_path?: Maybe<Scalars['String']['output']>;
  avatar_updated_at?: Maybe<Scalars['Datetime']['output']>;
  community_membersCollection?: Maybe<Community_MembersConnection>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  preferred_language?: Maybe<Scalars['String']['output']>;
};


export type ProfilesCommunity_MembersCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_MembersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Community_MembersOrderBy>>;
};

export type ProfilesConnection = {
  __typename?: 'profilesConnection';
  edges: Array<ProfilesEdge>;
  pageInfo: PageInfo;
};

export type ProfilesEdge = {
  __typename?: 'profilesEdge';
  cursor: Scalars['String']['output'];
  node: Profiles;
};

export type ProfilesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ProfilesFilter>>;
  avatar_path?: InputMaybe<StringFilter>;
  avatar_updated_at?: InputMaybe<DatetimeFilter>;
  display_name?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ProfilesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ProfilesFilter>>;
  preferred_language?: InputMaybe<StringFilter>;
};

export type ProfilesOrderBy = {
  avatar_path?: InputMaybe<OrderByDirection>;
  avatar_updated_at?: InputMaybe<OrderByDirection>;
  display_name?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  preferred_language?: InputMaybe<OrderByDirection>;
};

export type Push_Subscriptions = Node & {
  __typename?: 'push_subscriptions';
  auth: Scalars['String']['output'];
  created_at: Scalars['Datetime']['output'];
  endpoint: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  p256dh: Scalars['String']['output'];
  updated_at: Scalars['Datetime']['output'];
  user_id: Scalars['UUID']['output'];
};

export type Push_SubscriptionsConnection = {
  __typename?: 'push_subscriptionsConnection';
  edges: Array<Push_SubscriptionsEdge>;
  pageInfo: PageInfo;
};

export type Push_SubscriptionsEdge = {
  __typename?: 'push_subscriptionsEdge';
  cursor: Scalars['String']['output'];
  node: Push_Subscriptions;
};

export type Push_SubscriptionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Push_SubscriptionsFilter>>;
  auth?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  endpoint?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Push_SubscriptionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Push_SubscriptionsFilter>>;
  p256dh?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Push_SubscriptionsOrderBy = {
  auth?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  endpoint?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  p256dh?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type GetEventsForNoticeQueryVariables = Exact<{
  notice_id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetEventsForNoticeQuery = { __typename?: 'Query', community_eventsCollection?: { __typename?: 'community_eventsConnection', edges: Array<{ __typename?: 'community_eventsEdge', node: { __typename?: 'community_events', id: string, community_id: string, title: string, start_date: string, start_time?: string | null, end_date?: string | null, end_time?: string | null, notice_id: string, start_sort?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type ListCommunityEventsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_EventsFilter>;
  orderBy?: InputMaybe<Array<Community_EventsOrderBy> | Community_EventsOrderBy>;
}>;


export type ListCommunityEventsQuery = { __typename?: 'Query', community_eventsCollection?: { __typename?: 'community_eventsConnection', edges: Array<{ __typename?: 'community_eventsEdge', node: { __typename?: 'community_events', id: string, community_id: string, title: string, start_date: string, start_time?: string | null, end_date?: string | null, end_time?: string | null, notice_id: string, start_sort?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type IsCommunityAdminQueryVariables = Exact<{
  community_id: Scalars['UUID']['input'];
}>;


export type IsCommunityAdminQuery = { __typename?: 'Query', is_community_admin?: boolean | null };

export type IsMemberOfCommunityQueryVariables = Exact<{
  community_id: Scalars['UUID']['input'];
}>;


export type IsMemberOfCommunityQuery = { __typename?: 'Query', is_member_of_community?: boolean | null };

export type WasMemberOfArchivedCommunityQueryVariables = Exact<{
  community_id: Scalars['UUID']['input'];
}>;


export type WasMemberOfArchivedCommunityQuery = { __typename?: 'Query', was_member_of_archived_community?: boolean | null };

export type GetCommunityFirstUnreadNoticeIdQueryVariables = Exact<{
  community_id: Scalars['UUID']['input'];
}>;


export type GetCommunityFirstUnreadNoticeIdQuery = { __typename?: 'Query', get_community_first_unread_notice_id?: string | null };

export type GetCommunityMembersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Community_Members_With_ProfileFilter>;
}>;


export type GetCommunityMembersQuery = { __typename?: 'Query', community_members_with_profileCollection?: { __typename?: 'community_members_with_profileConnection', edges: Array<{ __typename?: 'community_members_with_profileEdge', node: { __typename?: 'community_members_with_profile', nodeId: string, user_id?: string | null, role?: string | null, display_name?: string | null, avatar_path?: string | null, avatar_updated_at?: any | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetCommunityAdminSampleQueryVariables = Exact<{
  community_id: Scalars['UUID']['input'];
}>;


export type GetCommunityAdminSampleQuery = { __typename?: 'Query', community_membersCollection?: { __typename?: 'community_membersConnection', edges: Array<{ __typename?: 'community_membersEdge', node: { __typename?: 'community_members', user_id: string } }> } | null };

export type GetMyCommunitiesFeedQueryVariables = Exact<{
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetMyCommunitiesFeedQuery = { __typename?: 'Query', my_communities_feedCollection?: { __typename?: 'my_communities_feedConnection', edges: Array<{ __typename?: 'my_communities_feedEdge', node: { __typename?: 'my_communities_feed', id?: string | null, name?: string | null, allow_guest_joins?: boolean | null, calendar_enabled?: boolean | null, role?: string | null, icon_path?: string | null, icon_updated_at?: any | null, last_notice_title?: string | null, last_notice_publish_at?: any | null, unread_count?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetMyCommunitiesQueryVariables = Exact<{
  user_id: Scalars['UUID']['input'];
}>;


export type GetMyCommunitiesQuery = { __typename?: 'Query', community_membersCollection?: { __typename?: 'community_membersConnection', edges: Array<{ __typename?: 'community_membersEdge', node: { __typename?: 'community_members', role: string, communities?: { __typename?: 'communities', id: string, name: string, allow_guest_joins: boolean, calendar_enabled: boolean, archived_at?: any | null, icon_path?: string | null, icon_updated_at?: any | null } | null } }> } | null };

export type GetNoticesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NoticesFilter>;
  orderBy?: InputMaybe<Array<NoticesOrderBy> | NoticesOrderBy>;
}>;


export type GetNoticesQuery = { __typename?: 'Query', noticesCollection?: { __typename?: 'noticesConnection', edges: Array<{ __typename?: 'noticesEdge', node: { __typename?: 'notices', nodeId: string, id: string, title: string, parts: any, community_id: string, publish_at?: any | null, created_at: any, updated_at: any, notice_imagesCollection?: { __typename?: 'notice_imagesConnection', edges: Array<{ __typename?: 'notice_imagesEdge', node: { __typename?: 'notice_images', id: string, storage_path: string, sort_order: number } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetNoticeSummariesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NoticesFilter>;
  orderBy?: InputMaybe<Array<NoticesOrderBy> | NoticesOrderBy>;
}>;


export type GetNoticeSummariesQuery = { __typename?: 'Query', noticesCollection?: { __typename?: 'noticesConnection', edges: Array<{ __typename?: 'noticesEdge', node: { __typename?: 'notices', id: string, title: string, community_id: string, publish_at?: any | null, created_at: any, updated_at: any } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetNoticeHeaderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetNoticeHeaderQuery = { __typename?: 'Query', noticesCollection?: { __typename?: 'noticesConnection', edges: Array<{ __typename?: 'noticesEdge', node: { __typename?: 'notices', id: string, title: string, community_id: string, publish_at?: any | null } }> } | null };

export type GetNoticeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetNoticeQuery = { __typename?: 'Query', noticesCollection?: { __typename?: 'noticesConnection', edges: Array<{ __typename?: 'noticesEdge', node: { __typename?: 'notices', nodeId: string, id: string, title: string, parts: any, community_id: string, publish_at?: any | null, created_at: any, updated_at: any, notice_imagesCollection?: { __typename?: 'notice_imagesConnection', edges: Array<{ __typename?: 'notice_imagesEdge', node: { __typename?: 'notice_images', id: string, storage_path: string, sort_order: number } }> } | null } }> } | null };

export type GetProfileQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetProfileQuery = { __typename?: 'Query', profilesCollection?: { __typename?: 'profilesConnection', edges: Array<{ __typename?: 'profilesEdge', node: { __typename?: 'profiles', id: string, display_name?: string | null, email?: string | null, preferred_language?: string | null, avatar_path?: string | null, avatar_updated_at?: any | null } }> } | null };

export const GetEventsForNoticeDocument = gql`
    query GetEventsForNotice($notice_id: UUID!, $after: Cursor) {
  community_eventsCollection(
    filter: {notice_id: {eq: $notice_id}}
    first: 100
    after: $after
    orderBy: [{start_sort: AscNullsLast}, {id: AscNullsLast}]
  ) {
    edges {
      node {
        id
        community_id
        title
        start_date
        start_time
        end_date
        end_time
        notice_id
        start_sort
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventsForNoticeGQL extends Apollo.Query<GetEventsForNoticeQuery, GetEventsForNoticeQueryVariables> {
    document = GetEventsForNoticeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCommunityEventsDocument = gql`
    query ListCommunityEvents($first: Int!, $after: Cursor, $filter: community_eventsFilter, $orderBy: [community_eventsOrderBy!]) {
  community_eventsCollection(
    first: $first
    after: $after
    filter: $filter
    orderBy: $orderBy
  ) {
    edges {
      node {
        id
        community_id
        title
        start_date
        start_time
        end_date
        end_time
        notice_id
        start_sort
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCommunityEventsGQL extends Apollo.Query<ListCommunityEventsQuery, ListCommunityEventsQueryVariables> {
    document = ListCommunityEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsCommunityAdminDocument = gql`
    query IsCommunityAdmin($community_id: UUID!) {
  is_community_admin(p_community_id: $community_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsCommunityAdminGQL extends Apollo.Query<IsCommunityAdminQuery, IsCommunityAdminQueryVariables> {
    document = IsCommunityAdminDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsMemberOfCommunityDocument = gql`
    query IsMemberOfCommunity($community_id: UUID!) {
  is_member_of_community(p_community_id: $community_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsMemberOfCommunityGQL extends Apollo.Query<IsMemberOfCommunityQuery, IsMemberOfCommunityQueryVariables> {
    document = IsMemberOfCommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WasMemberOfArchivedCommunityDocument = gql`
    query WasMemberOfArchivedCommunity($community_id: UUID!) {
  was_member_of_archived_community(p_community_id: $community_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WasMemberOfArchivedCommunityGQL extends Apollo.Query<WasMemberOfArchivedCommunityQuery, WasMemberOfArchivedCommunityQueryVariables> {
    document = WasMemberOfArchivedCommunityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCommunityFirstUnreadNoticeIdDocument = gql`
    query GetCommunityFirstUnreadNoticeId($community_id: UUID!) {
  get_community_first_unread_notice_id(p_community_id: $community_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCommunityFirstUnreadNoticeIdGQL extends Apollo.Query<GetCommunityFirstUnreadNoticeIdQuery, GetCommunityFirstUnreadNoticeIdQueryVariables> {
    document = GetCommunityFirstUnreadNoticeIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCommunityMembersDocument = gql`
    query GetCommunityMembers($first: Int, $after: Cursor, $filter: community_members_with_profileFilter) {
  community_members_with_profileCollection(
    filter: $filter
    first: $first
    after: $after
    orderBy: [{role: AscNullsLast}, {user_id: AscNullsLast}]
  ) {
    edges {
      node {
        nodeId
        user_id
        role
        display_name
        avatar_path
        avatar_updated_at
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCommunityMembersGQL extends Apollo.Query<GetCommunityMembersQuery, GetCommunityMembersQueryVariables> {
    document = GetCommunityMembersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCommunityAdminSampleDocument = gql`
    query GetCommunityAdminSample($community_id: UUID!) {
  community_membersCollection(
    filter: {and: [{community_id: {eq: $community_id}}, {role: {eq: "admin"}}]}
    first: 2
  ) {
    edges {
      node {
        user_id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCommunityAdminSampleGQL extends Apollo.Query<GetCommunityAdminSampleQuery, GetCommunityAdminSampleQueryVariables> {
    document = GetCommunityAdminSampleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMyCommunitiesFeedDocument = gql`
    query GetMyCommunitiesFeed($after: Cursor) {
  my_communities_feedCollection(
    first: 30
    after: $after
    orderBy: [{activity_at: DescNullsLast}, {id: AscNullsLast}]
  ) {
    edges {
      node {
        id
        name
        allow_guest_joins
        calendar_enabled
        role
        icon_path
        icon_updated_at
        last_notice_title
        last_notice_publish_at
        unread_count
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMyCommunitiesFeedGQL extends Apollo.Query<GetMyCommunitiesFeedQuery, GetMyCommunitiesFeedQueryVariables> {
    document = GetMyCommunitiesFeedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMyCommunitiesDocument = gql`
    query GetMyCommunities($user_id: UUID!) {
  community_membersCollection(first: 100, filter: {user_id: {eq: $user_id}}) {
    edges {
      node {
        role
        communities {
          id
          name
          allow_guest_joins
          calendar_enabled
          archived_at
          icon_path
          icon_updated_at
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMyCommunitiesGQL extends Apollo.Query<GetMyCommunitiesQuery, GetMyCommunitiesQueryVariables> {
    document = GetMyCommunitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNoticesDocument = gql`
    query GetNotices($first: Int, $after: Cursor, $filter: noticesFilter, $orderBy: [noticesOrderBy!]) {
  noticesCollection(
    first: $first
    after: $after
    filter: $filter
    orderBy: $orderBy
  ) {
    edges {
      node {
        nodeId
        id
        title
        parts
        community_id
        publish_at
        created_at
        updated_at
        notice_imagesCollection(orderBy: [{sort_order: AscNullsLast}]) {
          edges {
            node {
              id
              storage_path
              sort_order
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNoticesGQL extends Apollo.Query<GetNoticesQuery, GetNoticesQueryVariables> {
    document = GetNoticesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNoticeSummariesDocument = gql`
    query GetNoticeSummaries($first: Int, $after: Cursor, $filter: noticesFilter, $orderBy: [noticesOrderBy!]) {
  noticesCollection(
    first: $first
    after: $after
    filter: $filter
    orderBy: $orderBy
  ) {
    edges {
      node {
        id
        title
        community_id
        publish_at
        created_at
        updated_at
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNoticeSummariesGQL extends Apollo.Query<GetNoticeSummariesQuery, GetNoticeSummariesQueryVariables> {
    document = GetNoticeSummariesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNoticeHeaderDocument = gql`
    query GetNoticeHeader($id: UUID!) {
  noticesCollection(filter: {id: {eq: $id}}, first: 1) {
    edges {
      node {
        id
        title
        community_id
        publish_at
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNoticeHeaderGQL extends Apollo.Query<GetNoticeHeaderQuery, GetNoticeHeaderQueryVariables> {
    document = GetNoticeHeaderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNoticeDocument = gql`
    query GetNotice($id: UUID!) {
  noticesCollection(filter: {id: {eq: $id}}, first: 1) {
    edges {
      node {
        nodeId
        id
        title
        parts
        community_id
        publish_at
        created_at
        updated_at
        notice_imagesCollection(orderBy: [{sort_order: AscNullsLast}]) {
          edges {
            node {
              id
              storage_path
              sort_order
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNoticeGQL extends Apollo.Query<GetNoticeQuery, GetNoticeQueryVariables> {
    document = GetNoticeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProfileDocument = gql`
    query GetProfile($id: UUID!) {
  profilesCollection(filter: {id: {eq: $id}}, first: 1) {
    edges {
      node {
        id
        display_name
        email
        preferred_language
        avatar_path
        avatar_updated_at
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProfileGQL extends Apollo.Query<GetProfileQuery, GetProfileQueryVariables> {
    document = GetProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }